import routes from '@/router'
import { clearStorageAtom } from '@/store/root.ts'
import ErrorBoundaryWrapper from '@c/error-boundary'
import { useRoutes } from 'react-router'
import { useCheckUpdates } from './hooks'
import './App.scss'

const consoleError = console.error.bind(console)

console.error = (errObj, ...args) =>
  !(
    __DEV__ &&
    ((typeof errObj === 'string' && errObj.includes('findDOMNode')) ||
      (typeof errObj.message === 'string' && errObj.message.includes('findDOMNode')) ||
      args.includes('findDOMNode'))
  ) && consoleError(errObj, ...args)

/**
 *
 */
function App() {
  useCheckUpdates()
  const element = useRoutes(routes)
  const location = useLocation()

  const clearStorage = useSetAtom(clearStorageAtom)

  useEffect(() => {
    window.addEventListener('die', clearStorage)

    return () => {
      window.removeEventListener('die', clearStorage)
    }
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <div className="app">
      <ErrorBoundaryWrapper>{element}</ErrorBoundaryWrapper>
    </div>
  )
}

export default App
